const Line = () => {
  return (
    <svg width="12" height="120" viewBox="0 0 12 120" fill="none">
      <path d="M6 120L11.7735 110H0.226497L6 120ZM7 111L7 0H5L5 111H7Z" fill="#100069" />
    </svg>
  );
};

export default Line;
